import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
export function Guarantee() {
  return <section className="bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-160" data-mp="1o33t0dp8bmg6">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-161" data-mp="223y26yk3prfw">
        <div className="flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold-400 bg-brand-900 text-white" data-id="element-162" data-mp="1x4l8btutbk3t">
          <ShieldCheckIcon className="h-8 w-8 text-gold-400" aria-hidden="true" data-id="element-163" data-mp="19fiu6vze09e2" />
          <span className="mt-1 text-2xl font-extrabold leading-none" data-id="element-164" data-mp="14gfnz87o7x4i">7-day</span>
          <span className="text-[10px] font-bold uppercase tracking-wide text-brand-200" data-id="element-165" data-mp="1j52c9zf9zz7v">Guarantee</span>
        </div>
        <h2 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-166" data-mp="1edkdni0q6aq2">
          Explore the roadmap with confidence
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-167" data-mp="lpg1qerk91ex">
          I want you to be able to review the materials and decide whether the structure fits your professional
          workflow. If you purchase the collection and decide it isn't right for you, you can request a refund
          within seven days of purchase, subject to the published refund policy.
        </p>
        <p className="mt-4 text-lg font-bold text-ink" data-id="element-168" data-mp="yrp3htq5vs4c">Your purchase is covered by our 7-day money-back guarantee.</p>
        <SectionCTA label="Get instant access for $27" note="Zero risk · 7-day money-back guarantee" data-id="element-169" data-mp="60xbl8g4ppmt" />
      </div>
    </section>;
}